import React from 'react';
import styles from './settings-ui.module.css';

export interface SettingsInfoRowProps {
  label: string;
  value: string | React.ReactNode;
  code?: boolean;
}

/**
 * SettingsInfoRow - Display key-value information
 * 
 * Used for displaying read-only information like Server, Username, etc.
 */
export const SettingsInfoRow: React.FC<SettingsInfoRowProps> = ({
  label,
  value,
  code = false,
}) => {
  return (
    <div className={styles.infoRow}>
      <span className={styles.infoLabel}>{label}</span>
      <div className={styles.infoValue}>
        {code ? <code>{value}</code> : value}
      </div>
    </div>
  );
};

export default SettingsInfoRow;
